import { memo } from "react";
import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import type { FeatureTabItemType } from "@/components/features/_layouts";
import { FeatureIslandHeaderAndTab } from "@/components/features/_layouts";

const tabArray = (hotelID: string): FeatureTabItemType[] => [
	{
		tabTitle: "収支",
		path: generatePath(PATHS.HOTEL.MANAGEMENT.SALES.TOP, { hotelID }),
		tablet: true,
	},
	{
		tabTitle: "領収書",
		path: generatePath(PATHS.HOTEL.MANAGEMENT.SALES.RECEIPTS, { hotelID }),
		tablet: true,
	},
];

type Props = {
	hotelID: string;
};

/**
 * 収支の管理の見出しと、収支・領収書を切り替えるタブ
 */
export const SalesHeaderAndTab = memo(({ hotelID }: Props) => (
	<FeatureIslandHeaderAndTab headerProps={{ title: "収支の管理" }} tabProps={{ tabArray: tabArray(hotelID) }} />
));

SalesHeaderAndTab.displayName = "SalesHeaderAndTab";
